/* eslint-disable */

function HeaderBuilder(isXfinity) {
    let externalDiv;
    let headerContainer;
    let bodyData;
    let landingPageUrl;

    this.setData = function (bodyDataI) {
        bodyData = bodyDataI;
    };

    this.setExternalDiv = function (externalDivI) {
        externalDiv = externalDivI;
    };

    this.drawComponent = function () {
        construct();
    };

    function checkPage() {
        return document.querySelector('.page-simple-quote-form') === null ? true : false;
    }

    function construct() {
        headerContainer = externalDiv.jsAppend('div').jsAddClass('header');

        constructIconContainer();
        if (document.querySelector('.page-floating-quote-form') === null) constructButtonContainer();
        constructLinks();
    }

    function constructIconContainer() {
        headerContainer
            .jsAppend('div')
            .jsAddClass('iconContainer', isXfinity ? 'xfinityHeaderIconContainer' : 'headerIconContainer')
            .jsAddEventListener('click', function () {
                const url = checkPage() ? `${landingPageUrl}'&utm_content=hippo-xfinity-logo'` : landingPageUrl;
                window.open(url, '_blank');
            });
    }

    function constructButtonContainer() {
        let headerButtonContainer = headerContainer
            .jsAppend('div')
            .jsAddClass('headerButtonContainer')
            .jsAddEventListener('click', function () {
                const url = checkPage() ? `${landingPageUrl}'&utm_content=top-cta-get-quote'` : landingPageUrl;
                window.open(url, '_blank');
            });

        const buttonText = document.body.classList.contains('smart-sensor-outbrain')
            ? 'GET AN INSTANT QUOTE'
            : 'GET A QUOTE';

        headerButtonContainer.jsAppend('p').jsText(buttonText);
    }

    function constructLinks() {
        const params = checkPage()
            ? '?utm_medium=referral-link&utm_source=' + bodyData.source + '&utm_campaign=' + bodyData.campaign
            : '?utm_campaign=home-insurance-guide';
        const xfinityUTMParams = window.location.search || params;

        landingPageUrl = isXfinity ? 'https://myhippo.com/xfinity' + xfinityUTMParams : 'https://myhippo.com';
    }
}
